<template>
    <div>
        <div class="lableFormContainer">
            <h2 v-if="'inStyle'===crew">Instagram Handle</h2>
            <h2 v-else>Username</h2>
        </div>
        <div id="usernameError" class="error errorBox" style="display: none"><strong>Bitte beantworte die Frage</strong></div>
        <input type="text" v-model="account.username" id="username">
        
        <div class="lableFormContainer" v-if="'inStyle'!==crew">
            <h2>Link zu deinem Instagram Profil</h2>
        </div>
        <div id="instagramErrorUrl" class="errorBox error" style="display: none"><strong>Bitte gib eine gültige URL ein</strong></div>
        <div id="instagramError" class="error errorBox" style="display: none"><strong>Bitte beantworte die Frage</strong></div>
        <input type="text" v-model="additionalQuestions.instagram" id="instagram" v-if="'inStyle'!==crew" name="additionalQuestions.instagram">
        <div class="lableFormContainer" v-if="'inStyle'!==crew">
            <h2>Link zu deinem TikTok Profil</h2>
            <p>Bitte gib mindestens einen Link zu deinem Instagram- oder TikTok-Profil an</p>
        </div>
        <div id="tiktokErrorUrl" class="errorBox error" style="display: none"><strong>Bitte gib eine gültige URL ein</strong></div>
        <div id="tiktokError" class="error errorBox" style="display: none"><strong>Bitte beantworte die Frage</strong></div>
        <input type="text" v-model="additionalQuestions.tiktok" id="tiktok" v-if="'inStyle'!==crew" name="additionalQuestions.tiktok">
        
        <div class="lableFormContainer">
            <h2 v-if="'inStyle'===crew">E-Mail Adresse</h2>
            <h2 v-else>Email-Adresse</h2>
        </div>
        <div id="emailError" class="error errorBox" style="display: none"><strong>Bitte beantworte die Frage</strong></div>
        <input type="text" v-model="account.email" id="email">
        
        <div class="lableFormContainer"><h2>Passwort</h2></div>
        <div id="password1Error" class="error errorBox" style="display: none"><strong>Bitte beantworte die Frage / überprüfe die Übereinstimmung</strong></div>
        <input type="password" v-model="account.password" id="password1">
        
        <div class="lableFormContainer"><h2>Passwort wiederholen</h2></div>
        <div id="password2Error" class="error errorBox" style="display: none"><strong>Bitte beantworte die Frage / überprüfe die Übereinstimmung</strong></div>
        <input type="password" v-model="account.repeatedPassword" id="password2">
	</div>
</template>

<script>
	export default {
		name: 'account-registration',
		props: {
			account: Object,
			additionalQuestions: Object,
            crew: {
	    		type: String,
		    	required: false,
			    default: null
			}
        },
	}
</script>


// WEBPACK FOOTER //
// AccountRegistration.vue?356b435c